export default import.meta.ROLLUP_FILE_URL_VmS5CERYUTi8$T7Ds_yqqg